import Skeleton from 'react-loading-skeleton';

/**
 * Skeleton for a single card: title line, subtitle line, two action buttons.
 */
export function CardSkeleton() {
  return (
    <div className="rounded-xl border border-border-secondary bg-bg-raised p-4">
      <Skeleton width="60%" height={16} />
      <Skeleton width="80%" height={12} className="mt-2" />
      <div className="flex gap-2 mt-4">
        <Skeleton width={80} height={32} borderRadius={6} />
        <Skeleton width={60} height={32} borderRadius={6} />
      </div>
    </div>
  );
}
